<template lang="pug">
  .ui-simple-files(v-if="files && files.items && files.items.length")
    b-modal(:active.sync="modalActive")
      img(:src="modalImage")
    a.media.pt-5.mt-5(v-if="files && files.items" v-for="file in files.items" :key="file.id" :href="file.download_url" @click="click($event, file)")
      | {{ file.name }}
</template>

<script>
export default {
  name: 'ui-simple-files',
  props: {
    files: [Object, Array],
  },
  data: () => ({
    modalActive: false,
    modalImage: '',
  }),
  methods: {
    click(event, file) {
      if (file.isImage()) {
        this.modalActive = true;
        this.modalImage = file.getImageUrl();
        event.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss">
.ui-files {
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  .image {
    width: 130px;
    min-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    padding: 3px;
    background-color: rgba(0, 0, 0, 0.1);
    img {
      border-radius: 3px;
    }
  }
}
</style>
